module.exports = __webpack_public_path__ + "static/media/cardiacrehab.6e641cb2.mp4";